import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { CustomInput } from '../../../../shared/uiComponents';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getMBHLogs } from '../../../../redux/State/clientSlice/billingSlice';

const MBHStatus = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const [showInfo, setShowInfo] = useState<boolean>(false);

	const logsStatus = useSelector((state) => state.billing.mbhLogsStatus);

	const onClickEndAdornment = () => setShowInfo(!showInfo);

	useEffect(() => {
		dispatch(getMBHLogs());
	}, [dispatch]);

	const infoText = `${
		logsStatus?.syncStatus ? `Succeed. Synced sessions: ${logsStatus.syncedSessionCount}` : 'Failed'
	}`;

	return logsStatus ? (
		<CustomInput
			label="MBH Sync Date:"
			value={dayjs(logsStatus.createdAt).format('MM/DD/YYYY')}
			endAdornment={<FontAwesomeIcon icon={faCircleInfo} onClick={onClickEndAdornment} />}
			description={showInfo ? infoText : ''}
		/>
	) : null;
};

export default MBHStatus;
